<nb-card>
  <nb-card-header>
    <ngx-view-receipt
      [shopId]="shopId"
      [shop]="shop"
      [receipt]="receipt"
      [mode]="'detail'"
    >
    </ngx-view-receipt>
  </nb-card-header>
  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <nb-toggle
            status="primary"
            size="tiny"
            labelPosition="right"
            [(ngModel)]="receipt.isDelivery"
          >
            <span>{{
              receipt.isDelivery ? "Hẹn giao hàng" : "Không hẹn giao hàng"
            }}</span>
          </nb-toggle>
        </div>

        <div class="form-group">
          <label class="label">Ngày dự kiến giao hàng </label>
          <nb-form-field>
            <input
              nbInput
              shape="semi-round"
              placeholder="Chọn ngày giao hàng"
              [nbDatepicker]="deliveryDate"
              [(ngModel)]="receipt.deliveryDate"
            />
            <nb-datepicker
              style="width: 120px"
              #deliveryDate
              format="dd/MM/yyyy"
            ></nb-datepicker>
          </nb-form-field>
        </div>

        <div class="form-group">
          <label class="label">Nhân viên giao hàng </label>
          <ngx-view-selection-object
            [shopId]="shopId"
            [title]="'Chọn nhân viên giao hàng'"
            [prefix]=""
            [allowCreate]="false"
            [objectType]="'employee'"
            [objectId]="receipt.employeeDeliveryId"
            [objectName]="receipt.employeeDeliveryName"
            [objects]="employeesDeliverer"
            (objectChange)="changeEmployee($event)"
          >
          </ngx-view-selection-object>
        </div>

        <div class="form-group">
          <label class="label">Ghi chú giao hàng </label>
          <textarea
            nbInput
            fullWidth
            rows="2"
            placeholder="Nhập ghi chú"
            class="form-control"
            [(ngModel)]="receipt.deliveryNote"
          ></textarea>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <nb-toggle
            status="danger"
            size="tiny"
            labelPosition="right"
            [(ngModel)]="receipt.isDelivered"
          >
            <span>{{
              receipt.isDelivered
                ? "Khách đã nhận hàng"
                : "Khách chưa nhận hàng"
            }}</span>
          </nb-toggle>
        </div>

        <div class="form-group">
          <label class="label">Ngày khách nhận hàng </label>
          <nb-form-field>
            <input
              nbInput
              shape="semi-round"
              placeholder="Chọn ngày giao hàng"
              [nbDatepicker]="deliveredDate"
              [(ngModel)]="receipt.deliveredDate"
            />
            <nb-datepicker
              style="width: 120px"
              #deliveredDate
              format="dd/MM/yyyy"
            ></nb-datepicker>
          </nb-form-field>
        </div>

        <div class="form-group">
          <label class="label">Chi phí giao hàng </label>
          <nb-form-field>
            <input
              type="text"
              nbInput
              shape="semi-round"
              class="form-control"
              [status]="receipt.deliveredAmount > 0 ? 'primary' : 'danger'"
              [(ngModel)]="receipt.deliveredAmount"
              [ngxNumberFormat]="formatCurrency"
            />
          </nb-form-field>
        </div>

        <div class="form-group">
          <label class="label">Ghi chú phản hồi khách </label>
          <textarea
            nbInput
            fullWidth
            rows="2"
            placeholder="Nhập ghi chú"
            class="form-control"
            [(ngModel)]="receipt.deliveredNote"
          ></textarea>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
      Đóng
    </button>

    <button
      nbButton
      status="primary"
      size="small"
      [class.btn-pulse]="submitted"
      (click)="saveDelivery()"
    >
      <nb-icon icon="save-outline"></nb-icon>
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
